import React from "react";
import { Navigate } from "react-router-dom";
import useCurrentUserAccess from "../../hooks/useCurrentUserAccess";

function DashboardRouter() {
  const { loading, platformRole, accountRole } = useCurrentUserAccess();

  const hostname = window.location.hostname.toLowerCase();
  const isDemoSubdomain =
    hostname !== "agentbookcrm.com" &&
    hostname !== "www.agentbookcrm.com" &&
    hostname.endsWith(".agentbookcrm.com") &&
    !hostname.startsWith("app.");

  const isPlatformAdmin = platformRole?.key_name === "platform_admin";
  const isPlatformEmployee = platformRole?.key_name === "platform_employee";
  const isPlatformSupport = platformRole?.key_name === "platform_support";

  const isAccountAdmin = accountRole?.key_name === "account_admin";
  const isAccountUser = accountRole?.key_name === "account_user";

  const isPlatformSide =
    !isDemoSubdomain && (isPlatformAdmin || isPlatformEmployee || isPlatformSupport);

  const isAccountSide = isDemoSubdomain || isAccountAdmin || isAccountUser;

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#f8fafc",
          color: "#334155",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        Loading dashboard...
      </div>
    );
  }

  if (isPlatformSupport) {
    return <Navigate to="/support-admin" replace />;
  }

  if (isPlatformSide) {
    return <Navigate to="/admin-dashboard" replace />;
  }

  if (isAccountSide) {
    return <Navigate to="/dashboard-home" replace />;
  }

  return <Navigate to="/dashboard-home" replace />;
}

export default DashboardRouter;